import React from "react";
import type { RadioProps } from "../../Radio";
import { Radio } from "../../Radio";
import { type ControlledFormInputProps } from "../types";
import FormInputWrapper from "./FormInputWrapper";

type ControlledRadioInputProps = ControlledFormInputProps<RadioProps>;

const ControlledRadioInput = (props: ControlledRadioInputProps) => (
  <FormInputWrapper
    {...props}
    as={Radio}
  />
);

export default ControlledRadioInput;
